import { useContext, useState, useEffect } from "react";
import { AppContext } from "../data/store";
import { ethers } from "ethers";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { CONTRACT_ABI, contractAddress } from "../data/contract";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const History = () => {
  const { user, message, setMessage } = useContext(AppContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    async function getTransactions() {
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(
          contractAddress,
          CONTRACT_ABI,
          signer
        );

        const availableTransactions = await contract.getAllTransactions();
        const structuredTransactions = availableTransactions.map(
          (transaction) => ({
            addressTo: transaction.receiver,
            amount: parseInt(transaction.amount._hex) / 10 ** 18,
            timestamp: new Date(
              transaction.timestamp.toNumber() * 1000
            ).toLocaleString(),
          })
        );

        setData(structuredTransactions);
        setMessage("");
      } catch (error) {
        setMessage(error.message);
      }
    }

    getTransactions();
  }, [user]);

  return (
    <div className="text-white  w-[40rem] mx-12">
      {message && (
        <p className="bg-[#67ca99] rounded-lg border-r-4 border-r-red-600 px-6 py-2 mb-12">
          {message}
        </p>
      )}
      <Table className="text-sm text-center my-12">
        <Thead>
          <Tr>
            <Th>Paid To</Th>
            <Th>Fees (ETH)</Th>
            <Th>Dated On</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item) => (
            <Tr key={item.timestamp}>
              <Td>{item.addressTo}</Td>
              <Td>{item.amount}</Td>
              <Td>{item.timestamp}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  );
};

export default History;
